function sendGATagTrackingEvent(category, action, label, value) {
    try {
        if (value) {
            gtag('event', action, {
                'event_category': category,
                'event_label': label,
                'value': value
            });
        } else {
            gtag('event', action, {
                'event_category': category,
                'event_label': label
            });
        }
    } catch (e) {
        sendRaygunError(e);
    }
}
